import { useMutation, UseMutationResult } from '@tanstack/react-query';

import { SaveMyProfileApiPayload } from '@/actions/my-profile/shared';
import updateMyProfile from '@/actions/my-profile/updateMyProfile';
import { MyProfile } from '@/types/my-profile.type';
import { ApiResponse } from '@/types/response.type';

export interface UseUpdateMyProfileReturn {
  mutate: (
    payload: SaveMyProfileApiPayload
  ) => Promise<ApiResponse<MyProfile> | undefined>;
  result: ApiResponse<MyProfile> | undefined;
  error: Error | null;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
}

export const useUpdateMyProfile = (): UseUpdateMyProfileReturn => {
  const mutation: UseMutationResult<
    ApiResponse<MyProfile> | undefined,
    Error,
    SaveMyProfileApiPayload
  > = useMutation({
    mutationFn: updateMyProfile,
  });

  return {
    mutate: mutation.mutateAsync,
    result: mutation.data,
    error: mutation.error,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    isLoading: mutation.isPending,
  };
};
